module.exports = __webpack_public_path__ + "img/access_lock_close.35c9632b.svg";